<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M2.29678 12.2664L2.72815 13.8763C3.23169 15.7555 3.48346 16.6952 4.05423 17.3046C4.5049 17.7858 5.08814 18.1225 5.73018 18.2722C6.54333 18.4618 7.48295 18.21 9.36222 17.7064C11.2414 17.2029 12.1811 16.9512 12.7905 16.3804C12.8411 16.333 12.89 16.2842 12.9374 16.2339C12.6589 16.2106 12.378 16.1658 12.0925 16.109C11.5124 15.9937 10.8231 15.8089 10.008 15.5905L9.91897 15.5667L9.8983 15.5612C9.01138 15.3235 8.27031 15.1245 7.67861 14.9108C7.05636 14.686 6.49097 14.4089 6.01087 13.9593C5.34924 13.3396 4.88624 12.5376 4.68039 11.6548C4.53103 11.0142 4.57373 10.3859 4.69018 9.73468C4.80178 9.11059 5.00221 8.36268 5.24235 7.46654L5.68768 5.80454L5.70334 5.74609C4.10288 6.17723 3.26048 6.4323 2.69869 6.95848C2.21751 7.40914 1.88078 7.99239 1.73108 8.63443C1.54148 9.44759 1.79324 10.3872 2.29678 12.2664Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.3604 8.9308L16.9289 10.5407C16.4254 12.42 16.1736 13.3596 15.6029 13.969C15.1522 14.4501 14.5689 14.7869 13.9269 14.9366C13.8467 14.9553 13.7653 14.9697 13.6818 14.98C12.9192 15.0741 11.9888 14.8247 10.2949 14.3709C8.41569 13.8673 7.47606 13.6156 6.86666 13.0448C6.38548 12.5941 6.04875 12.0109 5.89905 11.3688C5.70945 10.5556 5.96121 9.61605 6.46475 7.73683L6.89612 6.12694C6.96852 5.85675 7.03576 5.6058 7.09944 5.37264C7.47867 3.98428 7.73351 3.22045 8.2222 2.69869C8.67285 2.21751 9.2561 1.88078 9.89819 1.73108C10.7113 1.54148 11.6509 1.79324 13.5302 2.29678C15.4094 2.80033 16.349 3.05209 16.9584 3.62286C17.4396 4.07353 17.7764 4.65678 17.926 5.29883C18.1156 6.11197 17.8639 7.05158 17.3604 8.9308ZM9.21294 8.17288C9.30227 7.83946 9.64502 7.64159 9.97844 7.73094L14.0031 8.80939C14.3365 8.89872 14.5344 9.24138 14.445 9.5748C14.3557 9.90822 14.013 10.1061 13.6796 10.0167L9.65485 8.9383C9.32144 8.84897 9.1236 8.5063 9.21294 8.17288ZM8.5656 10.5874C8.65494 10.254 8.9976 10.0561 9.33102 10.1455L11.7459 10.7926C12.0793 10.8819 12.2771 11.2246 12.1878 11.558C12.0984 11.8914 11.7558 12.0893 11.4224 12L9.00752 11.3529C8.6741 11.2636 8.47619 10.9208 8.5656 10.5874Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'AccountsMergeIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>